import React, { useState, useEffect, memo } from "react"
import { Routes, Route } from "react-router-dom"
import ErrorAccess from "@/components/common/ErrorAccess"
import Loading from "@/components/common/Loading"
import Box from "@material-ui/core/Box"
import Dashboard from "@/pages/Dashboard"
import Profile from "@/pages/Profile"
import ProjectControlPanel from "@/pages/ProjectControlPanel"
import { useSelector, useDispatch } from "react-redux"
import RoleProtectRoute from "@/helpers/RoleProtectRoute"
import { userGetRoles } from "@/redux/actions/userRoleAction"
import RequestSnackbar from "@/components/common/RequestSnackbar"
import SuperAdmin from "@/pages/SuperAdmin"

const Content = memo(() => {
    const userData = useSelector((state) => state.userReducer)
    const [loginUserRoles, setLoginUserRoles] = useState({
        loading: true,
    })

    const superAdminRole = process.env.SUPER_ADMIN
    const managerRole = process.env.PROJECT_MANAGER
    const adminRole = process.env.ACCOUNT_HOLDER
    const projectSponsorRole = process.env.PROJECT_SPONSOR

    const userRoleData = useSelector((state) => state.userRoleReducer)
    const { loading: userLoading, user: loginUser } = userData // signed up user
    const { loading: userRoleLoading, userRolesArray, message: userRoleMessage, successStatus: userRoleSuccessStatus } = userRoleData // signed up user

    const dispatch = useDispatch()

    useEffect(() => {
        if (userData && userData.user.userId) {
            dispatch(userGetRoles(userData.user.userId))
            setLoginUserRoles({ loading: false })
        }
    }, [userData])

    // RoleProtectRoute - detect if the signed up user can visit the page
    // projectSponsorRole on Dashboard - project sponsor only view result but cannot edit
    return (
        <Box id="content">
            {userLoading || !loginUser || userRoleLoading || loginUserRoles.loading ? (
                <Loading content="Loading Login User Detail..." transformX={50} />
            ) : (
                <>
                    {!userRoleSuccessStatus ? (
                        <>
                            <ErrorAccess message="Cannot load content" />
                            <RequestSnackbar status={false} message={userRoleMessage} snackbarOpen />
                        </>
                    ) : (
                        <Routes>
                            <Route
                                path="super-admin/*"
                                element={
                                    <RoleProtectRoute
                                        allowedRoles={[superAdminRole]}
                                        loginUser={loginUser}
                                        loginUserRoles={userRolesArray[0]?.userRoles}
                                    >
                                        <SuperAdmin />
                                    </RoleProtectRoute>
                                }
                            />
                            <Route
                                path="dashboard/user/:userId/*"
                                element={
                                    <RoleProtectRoute
                                        allowedRoles={[managerRole, adminRole, projectSponsorRole]}
                                        loginUser={loginUser}
                                        loginUserRoles={userRolesArray[0]?.userRoles}
                                    >
                                        <Dashboard />
                                    </RoleProtectRoute>
                                }
                            />
                            <Route
                                path="project/:projectId"
                                element={
                                    <RoleProtectRoute
                                        allowedRoles={[managerRole, adminRole, projectSponsorRole]}
                                        loginUser={loginUser}
                                        loginUserRoles={userRolesArray[0]?.userRoles}
                                    >
                                        <ProjectControlPanel />
                                    </RoleProtectRoute>
                                }
                            />
                            <Route
                                path="profile"
                                element={
                                    <RoleProtectRoute
                                        allowedRoles={[managerRole, adminRole, projectSponsorRole]}
                                        loginUser={loginUser}
                                        loginUserRoles={userRolesArray[0]?.userRoles}
                                    >
                                        <Profile />
                                    </RoleProtectRoute>
                                }
                            />
                            <Route path="/error-access" element={<ErrorAccess errorComponent="Content" />} />
                            <Route
                                path="*"
                                element={
                                    userRolesArray[0]?.userRoles === superAdminRole ? (
                                        <RoleProtectRoute
                                            allowedRoles={[superAdminRole]}
                                            loginUser={loginUser}
                                            loginUserRoles={userRolesArray[0]?.userRoles}
                                        >
                                            <SuperAdmin />
                                        </RoleProtectRoute>
                                    ) : (
                                        <RoleProtectRoute
                                            allowedRoles={[managerRole, adminRole, projectSponsorRole]}
                                            loginUser={loginUser}
                                            loginUserRoles={userRolesArray[0]?.userRoles}
                                        >
                                            <Dashboard />
                                        </RoleProtectRoute>
                                    )
                                }
                            />
                        </Routes>
                    )}
                </>
            )}
        </Box>
    )
})

export default Content
